<script setup lang="ts">
import Paywall from '@/components/Dashboard/Paywall.vue'
import useWebsockets from '@/composables/websockets.ts'
import { provide } from 'vue'

const socket = useWebsockets()

provide('socket', socket)
</script>

<template>
  <Paywall>
    <router-view />
  </Paywall>
</template>
